/**
 * Base class for all filter input components.
 * Provides common functionality for filter components.
 * @class
 * @extends {HTMLElement}
 */
export class FilterBase extends HTMLElement {
    /**
     * Initialize the filter base component.
     * @constructor
     */
    constructor() {
        super();
        /** @type {Object|null} The filter configuration data */
        this._filterData = null;
    }

    /**
     * Sets the filter data and triggers a render.
     * @param {Object} data - The filter configuration data
     */
    set filterData(data) {
        this._filterData = data;
        this.render(); // Re-render when data is set
    }

    /**
     * Gets the current filter data.
     * @returns {Object|null} The filter configuration data
     */
    get filterData() {
        return this._filterData;
    }

    /**
     * Basic render method - subclasses should extend or override.
     * Only clears the content, subclasses will add input elements.
     */
    render() {
        if (!this._filterData) return;

        // Clear previous content
        this.innerHTML = '';
    
        // No label creation - this is now handled by matrix-search
    }

    /**
     * Method for subclasses to implement to get the current filter value.
     * @returns {*|null} The current filter value or null
     */
    getValue() {
        // Base implementation returns null, subclasses should override
        console.warn(`getValue() not implemented for ${this.constructor.name}`);
        return null;
    }

    /**
     * Called when the element is inserted into the DOM.
     * Adds a class and triggers initial render if needed.
     */
    connectedCallback() {
        this.classList.add('filter-component'); // Add class for easier selection

        // Initial render if data was set before connection
        if (this._filterData && !this.innerHTML) {
            this.render();
        }
    }

    // Define observed attributes if needed in the future, e.g., for label, name etc.
    // static get observedAttributes() { return ['label', 'name']; }
    // attributeChangedCallback(name, oldValue, newValue) { ... }
}
